/** ======================================= 注意，此文件为自动生成，不要手动修改！！================================ **/
import {base} from '../../../base';

export const infos = {
  'productInfo': {
    '__proto__': base,
    'name': 'productInfo',
    'desc': " [商城模块]商品详情",
    'url': '/api/product/info',
    'args': {
      id: {
        'pos': 0,
        'desc': "商品id",
        'demo': '',
      },

    },
    'returns': "{Promise<any>}\n{\n \"code\": 1,\n \"message\": \"success!\",\n \"data\": {\n   \"info\": {\n      // 商品ID\n     \"id\": \"12046\",\n     \"title\": \"猪头肉\",\n     \"description\": \"xxxxxxxxxxxxxxxxxxxxxxxx\",\n     \"unit\": \"个\",\n     // 发货模式 1:现货发货模式 2:预售发货模式\n     \"shipping_mode\": \"1\",\n     // 发货天数\n     \"shipping_days\": \"3\",\n     // 是否支持7天无理由退款 1:支持 2:不支持\n     \"is_7day_return_supported\": \"1\",\n      // 商品图片\n     \"productImages\": [\n       {\n          // \t图片类型 1=商品入户图 2=商品bannner图 3=商品介绍图\n         \"type\": \"1\",\n         \"url\": \"https://admin.bb.uninote.com.cn/oss?path=uploads/images/2020/12/f1cecad5ef235345f04934a9bacef0ef.png\"\n       }\n     ],\n     // \t单价最低的Sku\n     \"productSkuByMinPrice\": {\n       // 商品SKUID\n       \"id\": \"3741\",\n       // 库存\n       \"inventory_quantity\": \"10\",\n       // sku 图片\n       \"image\": \"https://admin.bb.uninote.com.cn/oss?path=img/WechatIMG1047041.jpeg\",\n       // \t商品SKU的规格，包含多个对象，每个对象字段如展开所示\n       \"product_spec\": [\n         {\n           // 规格名称对象\n           \"product_spec_key\": {\n             // 规格名称ID\n             \"id\": 513,\n             // \t规格名称\n             \"title\": \"重量\"\n           },\n           // 规格种类对象\n           \"product_spec_value\": {\n             // 规格种类ID\n             \"id\": 935,\n             // \t规格种类\n             \"value\": \"1KG\"\n           }\n         }\n       ],\n       // 商品SKU价格\n       \"price\": \"1\"\n     },\n     // \t商品促销活动\n     \"productPromotion\": {\n       // 促销活动ID\n       \"id\": \"12\",\n       // 开始时间\n       \"start_time\": \"1607443200\",\n       // 结束时间\n       \"end_time\": \"1609344000\",\n       //商品促销活动sku\n       \"productPromotionSku\": [\n         {\n           // 商品skuid\n           \"product_sku_id\": \"3741\",\n           // 促销价格\n           \"promotion_price\": \"12300\",\n           //促销数量\n           \"promotion_number\": \"123\",\n           //实际销售数量\n           \"used_number\": \"6\"\n         }\n       ]\n     },\n     // \t优惠券使用说明\n     \"coupon_text\": {\n       // 标题\n       \"title\": \"优惠券使用说明\",\n       //内容\n       \"text_list\": [\n         \"1、每位用户可以领取多张优惠券；\"\n       ]\n     },\n     // 优惠卷列表，包含多个对象，每个对象字段如展开所示\n     \"coupon_list\": [\n       {\n         // 优惠卷ID\n         \"id\": \"324\",\n         // 开始使用时间\n         \"use_start_time\": \"1607309101\",\n         // 结束使用时间\n         \"use_end_time\": \"1609344000\",\n         // 类型 1:无门槛 2:满减 3:折扣\n         \"type\": \"1\",\n         \"remarks\": \"阳仔确定优惠券\",\n         // 优惠券金额(折扣券为折扣,例0.85表示8.5折)\n         \"coupon_amount\": \"23\",\n         // 优惠券使用限制金额(无门槛或折扣券始终为0,满减券为满减条件)\n         \"coupon_limit_amount\": 0,\n         // \t用户是否已领取 true:已领取 false:未领取\n         \"user_is_pick\": false\n       }\n     ]\n   }\n }\n}\n",
  },
  'productSkuList': {
    '__proto__': base,
    'name': 'productSkuList',
    'desc': " [商城模块]商品SKU列表",
    'url': '/api/product/product-sku-list',
    'args': {
      id: {
        'pos': 0,
        'desc': "商品id",
        'demo': '',
      },

    },
    'returns': "{Promise<any>}\n{\n \"code\": 1,\n \"message\": \"success!\",\n \"data\": {\n   \"info\": {\n     // 商品ID\n     \"id\": \"12046\",\n     //商品SKU列表，包含多个对象，每个对象字段如展开所示\n     \"productSku\": [\n       {\n         // 商品SKUID\n         \"id\": \"3741\",\n         \"product_spec\": [\n           {\n             \"product_spec_key\": {\n               \"id\": 513,\n               \"title\": \"重量\"\n             },\n             \"product_spec_value\": {\n               \"id\": 935,\n               \"value\": \"1KG\"\n             }\n           }\n         ],\n         // 状态 1=正常 2=禁用\n         \"status\": \"1\",\n         // \tshu价格\n         \"price\": \"1\",\n         // 库存\n         \"inventory_quantity\": \"10\",\n         // sku 图片\n         \"image\": \"https://admin.bb.uninote.com.cn/oss?path=img/WechatIMG1047041.jpeg\"\n       }\n     ],\n     //商品规格名称列表，包含多个对象，每个对象字段如展开所示\n     \"productSpecKey\": [\n       {\n         //商品规格名称ID\n         \"id\": \"513\",\n         //\t规格名称\n         \"title\": \"重量\",\n         //\t商品规格种类列表，包含多个对象，每个对象字段如展开所示\n         \"productSpecValue\": [\n           {\n             //商品规格种类ID\n             \"id\": \"935\",\n             //规格种类名称\n             \"value\": \"1KG\"\n           }\n         ]\n       }\n     ]\n   }\n }\n}\n",
  },
  'productList': {
    '__proto__': base,
    'name': 'productList',
    'desc': " [商城模块]商品列表",
    'url': '/api/product/list',
    'args': {
      is_recommend: {
        'pos': 0,
        'desc': "是否过滤推荐商品(默认false:不过滤,返回所有上架商品 true:过滤,只返回推荐商品)",
        'demo': '',
      },
      pageSize: {
        'pos': 1,
        'desc': "分页显示数据条数 默认10",
        'demo': '',
      },
      page: {
        'pos': 2,
        'desc': "分页页码 默认1",
        'demo': '',
      },
      product_category_id: {
        'pos': 3,
        'desc': "分类ID",
        'demo': '',
      },
      product_promotion_category_id: {
        'pos': 4,
        'desc': "活动分类ID",
        'demo': '',
      },
      keyword_search: {
        'pos': 5,
        'desc': "关键字搜索",
        'demo': '',
      },

    },
    'returns': "{Promise<*>}\n{\n \"code\": 1,\n \"message\": \"success!\",\n \"data\": {\n   \"totalPage\": 5, // 总页数\n   \"currentPage\": 1, // 当前页\n   \"__info\": \"k\",\n   \"info\": [\n     {\n       \"id\": \"12049\", // 商品ID\n       \"title\": \"20201204测试商品\",\n       \"description\": \"xxxxxxxxxxxxxxxxxxxxxxxx\",\n       \"unit\": \"个\",\n       \"shipping_mode\": \"0\", // 发货模式 1:现货发货模式 2:预售发货模式\n       \"shipping_days\": \"0\", // 发货天数\n       \"is_7day_return_supported\": \"0\", // 是否支持7天无理由退款 1:支持 2:不支持\n       \"productImages\": {\n         \"type\": \"1\", // 图片类型 1=商品入户图 2=商品bannner图 3=商品介绍图\n         \"url\": \"https://admin.bb.uninote.com.cn/oss?path=xxx\"\n       },\n       \"productSkuByMinPrice\": {\n         \"id\": \"3758\", // 商品SKUID\n         \"price\": \"1\",\n         \"inventory_quantity\": \"0\", // 库存\n         \"image\": \"https://admin.bb.uninote.com.cn/oss?path=img/WechatIMG1047041.jpeg\" // sku 图片\n       },\n       \"__productPromotion\":  \"i\",\n       \"productPromotion\":  {\n         \"id\": \"5\", // 促销活动ID\n         \"start_time\": \"1605715800\",\n         \"end_time\": \"1605715861\",\n         \"productPromotionSku\": [{\n         \"product_sku_id\": \"3758\",\n         \"promotion_price\": \"1\",\n         \"promotion_number\": \"10\", // 促销数量\n         \"used_number\": \"0\" // 实际销售数量\n         }]\n         }\n       }\n     ]\n }\n}\n\n",
  },
  'hotKeywordSearchList': {
    '__proto__': base,
    'name': 'hotKeywordSearchList',
    'desc': " [商城模块]热搜关键词列表",
    'url': '/api/product/hot-keyword-search-list',
    'args': {

    },
    'returns': "{Promise<*>}\n{\n \"code\": 1,\n \"message\": \"success!\",\n \"data\": {\n   \"info\": [\n     \"测试\"\n   ]\n }\n}\n",
  },
  'productPromotionCategory': {
    '__proto__': base,
    'name': 'productPromotionCategory',
    'desc': " [商城模块]商品活动分类列表",
    'url': '/api/product/product-promotion-category',
    'args': {
      pageSize: {
        'pos': 0,
        'desc': "分页显示数据条数 默认10",
        'demo': '',
      },
      page: {
        'pos': 1,
        'desc': "分页页码 默认1",
        'demo': '',
      },

    },
    'returns': "{Promise<*>}\n{\n \"code\": 1,\n \"message\": \"success!\",\n \"data\": {\n   \"totalPage\": 13,\n   \"currentPage\": 1,\n   \"info\": [\n     {\n       // 分类ID\n       \"id\": \"155\",\n       // 分类名称\n       \"name\": \"测试2\",\n       // 副标题\n       \"subtitle\": \"xxx2\",\n       // 促销活动分类图片\n       \"product_promotion_category_image\": \"https://admin.bb.uninote.com.cn/oss?path=xxx\"\n     }\n   ]\n }\n}\n",
  }
};
